import React from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

import CheckIcon from '@material-ui/icons/Check';

import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import OnboardingAlert from 'Views/Onboarding/Components/OnboardingAlert';

import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import AccountSetupSection from '../../Components/AccountSetup/AccountSetupSection';
import { useSurveyContext } from '../../../SurveyContext';

const styles = (theme) => ({
  root: {},
  passwordInputField: {
    margin: theme.spacing(4, 0, 2, 0),
  },
  footer: {},
  alert: {
    marginTop: theme.spacing(2),
  },
});

function AccountSetupCreatePasswordLayout({
  classes,
}) {
  const {
    onSubmit: onSubmitMetaForm,
    resource,
  } = useMetaLayoutContext();

  // Hide navigator / header from Account Creation
  const { setNavbarVisibility, setHeaderVisibility } = useSurveyContext();
  React.useEffect(() => {
    setNavbarVisibility(false);
    setHeaderVisibility(false);
  }, []);

  const passwordsMatch = resource.attr('newPassword') === resource.attr('confirmPassword');

  return (
    <div className={classes.root}>
      {/* ---------- Section title / icon / message ---------- */}
      <AccountSetupSection
        title={'Let\'s start by creating a password'}
        showFacetIcon
      />

      <MetaControlField
        attr={'newPassword'}
        test={'account-setup-password-input'}
      />

      <MetaControlField
        attr={'confirmPassword'}
        test={'account-setup-confirm-password-input'}
      />

      {/* ---------- Passwords Match (Alert) ---------- */}
      <OnboardingAlert
        className={classes.alert}
        visible={resource.isValid() && passwordsMatch}
        AlertProps={{
          icon: <CheckIcon />,
          color: 'success',
          test: 'account-setup-passwords-match-alert',
        }}
        message={'Passwords Match'}
      />

      {/* ---------- Footer (Navigator) ---------- */}
      <SurveyStepFooter
        className={classes.footer}
        onSubmit={onSubmitMetaForm}
        NextButtonProps={{
          test: 'account-setup-create-password-submit-button',
          buttonLabel: 'Save Password',
        }}
      />
    </div>
  );
}

AccountSetupCreatePasswordLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

AccountSetupCreatePasswordLayout.defaultProps = {
};

export default withStyles(styles)(AccountSetupCreatePasswordLayout);
